export default __webpack_public_path__ + "images/b9d670a76a9a053c198a4fc095c20b58.png";